import apiOptions from '@/api/vo/option';

const defaultState = () => ({
	province: [],
	city: [],
	subdistrict: [],
	bank: [],
	optionDownline: [],
	listBankCities: [],
});

const state = defaultState();

const getters = {
};

const mutations = {

	setProvince(state, data) {
		state.province = data.data
	},
	setCity(state, data) {
		state.city = data.data
	},
	setSubdistrict(state, data) {
		state.subdistrict = data.data
	},
	setBank(state, data) {
		state.bank = data.data
	},
	setListBankCities(state, data) {
		state.listBankCities = data.data
		state.subdistricts = data.data
	},

	clearOptions(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {

	async getProvince({ dispatch, commit }) {
		return new Promise((resolve, reject) => {
			apiOptions.getProvince().then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setProvince', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Data provinsi tidak dapat ditampilkan, silahkan muat ulang halaman.'
				}, { root: true });
				reject()
			});
		});
	},
	async getCity({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOptions.getCity(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setCity', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Data kota/kabupaten tidak dapat ditampilkan, silahkan muat ulang halaman.'
				}, { root: true });
				reject()
			});
		});
	},
	async getSubdistrict({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOptions.getSubdistrict(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSubdistrict', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Data kecamatan tidak dapat ditampilkan, silahkan muat ulang halaman.'
				}, { root: true });
				reject()
			});
		});
	},
	async getBank({ dispatch, commit }) {
		return new Promise((resolve, reject) => {
			apiOptions.getBank().then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setBank', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Data bank tidak dapat ditampilkan, silahkan muat ulang halaman.'
				}, { root: true });
				reject()
			});
		});
	},

	async getBankCity({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOptions.getCity(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListBankCities', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setListBankCities', []);
				reject()
			});
		});
	},
	
	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};